/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCaretUp = createReactComponent("outline", "caret-up", "IconCaretUp", [["path", { "d": "M18 14l-6 -6l-6 6h12", "key": "svg-0" }]]);

export { IconCaretUp as default };
//# sourceMappingURL=IconCaretUp.mjs.map
